import { Volume2, Square } from "lucide-react";
import { useSpeaker } from "@/lib/voice";

export default function ReadAloud({ text, label = "Read aloud", size = "md", testId = "read-aloud-btn", className = "" }) {
  const { speaking, speak, stop } = useSpeaker();
  const big = size === "lg";
  const onClick = (e) => { e.preventDefault(); e.stopPropagation(); speaking ? stop() : speak(text); };
  return (
    <button type="button" data-testid={testId} onClick={onClick} aria-label={speaking ? "Stop reading" : label} title={speaking ? "Stop" : label}
      className={`inline-flex items-center justify-center gap-2 rounded-full border-2 transition-colors ${speaking ? "bg-[#2E7D6B] border-[#2E7D6B] text-white" : "bg-white border-[#E2D9CE] text-[#2E7D6B] hover:border-[#2E7D6B]"} ${big ? "min-h-[52px] px-5 text-lg font-semibold" : "w-11 h-11"} ${className}`}>
      {speaking ? <Square className={big ? "w-5 h-5" : "w-4 h-4"} fill="currentColor" /> : <Volume2 className={big ? "w-6 h-6" : "w-5 h-5"} />}
      {big && (speaking ? "Stop" : label)}
    </button>
  );
}

export const visitToSpeech = (r, isHelper = false) => {
  const when = (r.scheduled_at || r.scheduled_date || "").replace("T", " at ");
  const who = isHelper ? (r.seeker_name ? ` for ${r.seeker_name}` : "") : (r.helper_name ? `. ${r.helper_name} is your helper` : ". No helper has accepted yet");
  return `${r.title}${who}. ${r.location ? `At ${r.location}. ` : ""}${when ? `On ${when}. ` : ""}Status: ${(r.status || "").replace("_", " ")}.`;
};
